import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UsersroleService {
  private apiBaseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}

  saveUsersrole(usersroleItem: any): Observable<any> {
    const usersrole = { ...usersroleItem };
    delete usersrole.lastUpdated;
    delete usersrole.dateCreated;

    // TODO Per Multifarm???
    if (usersrole && usersrole.user && usersrole.role) {
      return this.http
        .post<any>(`${this.apiBaseUrl}api/private/v1/auth/usersrole`, usersrole, {
          observe: 'response',
        })
        .pipe(
          map((response) => {
            if (response.status === 200) {
              return { status: 'OK' };
            } else {
              return { status: 'KO' };
            }
          }),
          catchError((error) => of({ status: 'KO' }))
        );
    } else {
      return of({ status: 'KO' });
    }
  }
}
